import moment from "moment";
import {
  parseCategories,
  calPercentage,
  generateGfxCategories,
  generateGfxCategoriesPercentage,
  calcTotalStrikesThrown as calcStrikesThrown,
  calcTotalStrikesLanded as calcStrikesLanded,
} from "../../utils/CategoryUtils";

const CATEGORIES_CIQ = ["TOT", "ARM", "LEG", "GD", "TD", "KD", "SUB"];

const GFX_CATEGORIES_CIQ = [
  {
    name: "Arm Strikes",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[1] + ".Succ",
        missed: CATEGORIES_CIQ[1] + ".Att",
        stats: stats,
      });
    },
  },
  {
    name: "Leg Strikes",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[2] + ".Succ",
        missed: CATEGORIES_CIQ[2] + ".Att",
        stats: stats,
      });
    },
  },
  {
    name: "Ground Strikes",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[3] + ".Succ",
        missed: CATEGORIES_CIQ[3] + ".Att",
        stats: stats,
      });
    },
  },
  {
    name: "Knockdowns",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[5] + ".Succ",
        missed: CATEGORIES_CIQ[5] + ".Att",
        stats: stats,
      });
    },
  },
  {
    name: "Takedowns",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[4] + ".Succ",
        missed: CATEGORIES_CIQ[4] + ".Att",
        stats: stats,
      });
    },
  },
];

function calPercentageCIQ({ missed, landed, stats, round }) {
  let missed_total = stats
    ?.filter((r) => r?.round === round || !round)
    ?.reduce((prev, curr) => {
      var value = missed?.split(".").reduce((a, b) => a?.[b], curr);

      return prev + (value || 0);
    }, 0);
  let landed_total = stats
    ?.filter((r) => r?.round === round || !round)
    ?.reduce((prev, curr) => {
      var value = landed?.split(".").reduce((a, b) => a?.[b], curr);
      return prev + (value || 0);
    }, 0);
  let output = (landed_total || 0) + "/";

  output += (missed_total || 0) + (landed_total || 0);

  return output;
}

export class Cagenomics {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "FFStats";
    this.scene = "FFStats";
    this.data = [];
    this.page = 1000;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "006";
      }).value = options?.game?.home_fighter?.first_name.toUpperCase();

      xml.payload.field.find((item) => {
        return item.attr.name === "007";
      }).value = options?.game?.home_fighter?.last_name.toUpperCase();

      xml.payload.field.find((item) => {
        return item.attr.name === "P2001"; // Number
      }).value =
        options?.game?.competition?.fighter_full_path +
        (options.game?.home_fighter?.image || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "008";
      }).value = options?.game?.away_fighter?.first_name.toUpperCase();

      xml.payload.field.find((item) => {
        return item.attr.name === "009";
      }).value = options?.game?.away_fighter?.last_name?.toUpperCase();

      xml.payload.field.find((item) => {
        return item.attr.name === "P2002"; // Number
      }).value =
        options?.game?.competition?.fighter_full_path +
        (options.game?.away_fighter?.image || "");

      const categories = options?.game?.competition?.categories;
      const GFX_CATEGORIES = generateGfxCategories(categories);
      const GFX_CATEGORIES_PERCENT = generateGfxCategoriesPercentage(categories);

      let selectedStatsOrder = [];
      try {
        const stored = localStorage.getItem("cagenomics_stats_order");
        if (stored) {
          selectedStatsOrder = JSON.parse(stored);
        }
      } catch (err) {}

      const getCategory = (index, categoriesArray) => {
        if (selectedStatsOrder.length > index) {
          const selectedName = selectedStatsOrder[index];
          const found = categoriesArray.find((c) => c.name === selectedName);
          if (found) return found;
        }
        return categoriesArray[index];
      };

      xml.payload.field.find((item) => {
        return item.attr.name === "0120";
      }).value = getCategory(0, GFX_CATEGORIES)?.name?.toUpperCase() || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0220";
      }).value = getCategory(1, GFX_CATEGORIES)?.name?.toUpperCase() || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0320";
      }).value = getCategory(2, GFX_CATEGORIES)?.name?.toUpperCase() || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0420";
      }).value = getCategory(3, GFX_CATEGORIES)?.name?.toUpperCase() || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0521";
      }).value =
        calcStrikesLanded({ stats: options?.game?.home_player_stats, categories }) +
        "/" +
        calcStrikesThrown({ stats: options?.game?.home_player_stats, categories });


      xml.payload.field.find((item) => {
        return item.attr.name === "0522";
      }).value =
        calcStrikesLanded({ stats: options?.game?.away_player_stats, categories }) +
        "/" +
        calcStrikesThrown({ stats: options?.game?.away_player_stats, categories });

      xml.payload.field.find((item) => {
        return item.attr.name === "0621";
      }).value =
        ((calcStrikesLanded({ stats: options?.game?.home_player_stats, categories })) /
        (calcStrikesThrown({ stats: options?.game?.home_player_stats, categories }))
        * 100).toFixed(1) + "%";
       xml.payload.field.find((item) => {
        return item.attr.name === "0622";
      }).value =
        ((calcStrikesLanded({ stats: options?.game?.away_player_stats, categories })) /
        (calcStrikesThrown({ stats: options?.game?.away_player_stats, categories }))
        * 100).toFixed(1) + "%";
      // Category 1
      xml.payload.field.find((item) => {
        return item.attr.name === "0121";
      }).value =
        getCategory(0, GFX_CATEGORIES)?.stat(options?.game?.home_player_stats) || "0/0";

      xml.payload.field.find((item) => {
        return item.attr.name === "0122";
      }).value =
        getCategory(0, GFX_CATEGORIES)?.stat(options?.game?.away_player_stats) || "0/0";

      // Category 2
      xml.payload.field.find((item) => {
        return item.attr.name === "0221";
      }).value =
        getCategory(1, GFX_CATEGORIES)?.stat(options?.game?.home_player_stats) || "0/0";

      xml.payload.field.find((item) => {
        return item.attr.name === "0222";
      }).value =
        getCategory(1, GFX_CATEGORIES)?.stat(options?.game?.away_player_stats) || "0/0";

      // Category 3
      xml.payload.field.find((item) => {
        return item.attr.name === "0321";
      }).value =
        getCategory(2, GFX_CATEGORIES)?.stat(options?.game?.home_player_stats) || "0/0";

      xml.payload.field.find((item) => {
        return item.attr.name === "0322";
      }).value =
        getCategory(2, GFX_CATEGORIES)?.stat(options?.game?.away_player_stats) || "0/0";

      // Category 4
      xml.payload.field.find((item) => {
        return item.attr.name === "0421";
      }).value =
        getCategory(3, GFX_CATEGORIES)?.stat(options?.game?.home_player_stats) || "0";

      xml.payload.field.find((item) => {
        return item.attr.name === "0422";
      }).value =
        getCategory(3, GFX_CATEGORIES)?.stat(options?.game?.away_player_stats) || "0";
      
      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
